import React, { useEffect, useState } from "react";
import "./MedicallSupport.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import medicalImg from "../../Asset/Images/medicall.png";

/* IMAGES */
import g1 from "../../Asset/Images/p7.jpg";
import g2 from "../../Asset/Images/p10.jpg";
import g3 from "../../Asset/Images/p17.png";
import g4 from "../../Asset/Images/p18.png";
import g5 from "../../Asset/Images/iv4.jpeg";
import g6 from "../../Asset/Images/p3.jpeg";

const galleryImages = [g1, g2, g3, g4, g5, g6];

const MedicalSupport = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => { document.body.style.overflow = "auto"; };
  }, [selectedImage]);

  // Keys for the 6 detail cards
  const medicalDetails = [
    "medical.detail1",
    "medical.detail2",
    "medical.detail3",
    "medical.detail4",
    "medical.detail5",
    "medical.detail6"
  ];

  return (
    <section className="medical_section">
      {/* INTRO */}
      <div className="medical_intro">
        <div className="medical_img" data-aos="fade-right">
          <img src={medicalImg} alt={t('medical.intro_alt')} />
        </div>

        <div className="medical_text" data-aos="fade-left">
          <h2>
            {t('medical.title_start')} <span>{t('medical.title_end')}</span>
          </h2>
          <p>{t('medical.intro_p')}</p>
        </div>
      </div>

      {/* DETAILS GRID */}
      <div className="medical_grid">
        {medicalDetails.map((key, index) => (
          <div className="medical_card" key={index} data-aos="zoom-in">
            {t(key)}
          </div>
        ))}
      </div>

      {/* GALLERY */}
      <div className="medical_gallery">
        {galleryImages.map((img, index) => (
          <div
            className="medical_gallery_card"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 80}
            onClick={() => setSelectedImage(img)}
          >
            <img src={img} alt={`medical-gallery-${index}`} loading="lazy" />
            <div className="gallery_overlay">
              <button className="open_btn">{t('medical.view_detail')}</button>
            </div>
          </div>
        ))}
      </div>

      {/* IMAGE POPUP */}
      {selectedImage && (
        <div className="medical_popup_overlay" onClick={() => setSelectedImage(null)}>
          <button className="medical_popup_close" onClick={() => setSelectedImage(null)}>
            &times;
          </button>
          <div className="medical_popup_content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Medical Gallery Detail" />
          </div>
        </div>
      )}
    </section>
  );
};

export default MedicalSupport;